/**
 * This is a simplified system to have multiple components set the status of the game to be 'busy'
 * This doesn't trigger a pause on the game's API, it just tells outside components that
 * "Something Is Happening On The Game's Side"
 * Expected items to use this:
 * paytable, howToPlay, settings, wager, displayMessage
 */

import bus from "kernel/messagebus/MessageBus";

var ifBusy = false;
var lastReported;
var busyComponents = {};

//Note - we should have a busy set for gameReady so widgets aren't available immediately.
/**
 * Sets that a subcomponent is busy (ie paytable open)
 * Will send GameService\IXF.ToWidgets message when one or more components are busy,
 *   or if all components are no longer busy
 * @param componentName - name of the component - paytable, howToPlay, WagerState
 * @param ifComponentBusy - boolean, if busy or not.
 */
function setBusy(componentName, ifComponentBusy) {
    if (ifComponentBusy === undefined) { //If ifComponentBusy not set, this becomes basically a query
        return busyComponents[componentName];
    }
    busyComponents[componentName] = ifComponentBusy;
    ifBusy = false;
    Object.keys(busyComponents).forEach(function(key) {
        ifBusy = ifBusy || busyComponents[key];
    });
    //console.log('3PBUSY',componentName,'setting busy state:',ifComponentBusy);
    if (ifBusy !== lastReported) { //If the overall 'busy' state
        //console.log('3PBUSY','reporting busy state to widgets:',ifBusy);
        bus.publish({
            channel:"GameService",
            topic:"IXF.ToWidgets",
            data:{
                messageType:"gameBusy",
                messageData:ifBusy
            }
        });
        lastReported = ifBusy;
    }
}

export default setBusy;
